"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var getColorTheme_1 = __importDefault(require("./getColorTheme"));
var getFontTheme_1 = __importDefault(require("./getFontTheme"));
var makeCssProperty = function (cssProperty, props) {
    var _a;
    var property = lodash_1.default.camelCase(cssProperty);
    return props && (_a = {}, _a[property] = props, _a);
};
var convertToTheme = function (theme, cssProperty, value) {
    var isObject = typeof value === 'object';
    if (isObject) {
        return Object.keys(value).map(function (key) {
            return convertToTheme(theme, cssProperty, value[key]);
        });
    }
    if (cssProperty === 'font-size') {
        return makeCssProperty(cssProperty, (0, getFontTheme_1.default)(theme, value));
    }
    return makeCssProperty(cssProperty, (0, getColorTheme_1.default)(theme, value));
};
exports.default = convertToTheme;
